/**
 * Oleum PDP — recomendaciones inteligentes por producto.
 * Al cargar, obtiene los productos relacionados desde la Product Recommendations API
 * de Shopify (según el producto actual) y reemplaza el fallback renderizado en Liquid.
 * Si la API no devuelve productos, oculta el bloque completo.
 */
(function () {
  'use strict';

  var TAG = 'oleum-pdp-recommendations';

  function setSectionVisible(el, visible) {
    var section = el && el.closest ? el.closest('.shopify-section') : null;
    var root = el && el.closest ? el.closest('[data-oleum-pdp-recs-root]') : null;
    if (section) {
      section.style.display = visible ? '' : 'none';
    }
    if (root) {
      if (visible) root.removeAttribute('hidden');
      else root.setAttribute('hidden', '');
    }
  }

  class OleumPdpRecommendations extends HTMLElement {
    connectedCallback() {
      if (this._loaded) return;
      this._loaded = true;

      var existing = this.querySelectorAll('.grid__item');
      if (this.getAttribute('data-performed') === 'true') {
        setSectionVisible(this, existing.length > 0);
        return;
      }

      var base = this.getAttribute('data-url');
      var productId = this.getAttribute('data-product-id');
      if (!base || !productId) {
        setSectionVisible(this, existing.length > 0);
        return;
      }

      var params = new URLSearchParams({
        section_id: this.getAttribute('data-section-id') || '',
        product_id: productId,
        limit: this.getAttribute('data-limit') || '6'
      });
      var intent = this.getAttribute('data-intent');
      if (intent) params.set('intent', intent);

      var self = this;
      fetch(base + '?' + params.toString(), { headers: { Accept: 'text/html' } })
        .then(function (res) {
          if (!res.ok) throw new Error('rec fetch failed');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector(TAG);
          if (!fresh) {
            setSectionVisible(self, existing.length > 0);
            return;
          }
          var items = fresh.querySelectorAll('.grid__item');
          if (!items.length) {
            setSectionVisible(self, false);
            return;
          }

          self.innerHTML = fresh.innerHTML;
          self.setAttribute('data-performed', 'true');
          setSectionVisible(self, true);

          self.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
          if (typeof window.initOleumProductCardCtas === 'function') {
            window.initOleumProductCardCtas(self);
          }
          if (typeof window.initOleumCardBeneficiosIn === 'function') {
            window.initOleumCardBeneficiosIn(self);
          }
        })
        .catch(function () {
          setSectionVisible(self, existing.length > 0);
        });
    }
  }

  if (typeof customElements !== 'undefined' && !customElements.get(TAG)) {
    customElements.define(TAG, OleumPdpRecommendations);
  }
})();
